import type { AssetTypeTemplateInfoProps } from "./asset-type-template-info.type";

import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import { useGetEntityTemplateAssetTypes } from "@/entities/asset-types";
import { AssetTypesListBreadcrumb } from "@/modules/asset-types/asset-types-list-breadcrumb";
import { FlexContainerJsx, FlexContainerText } from "@/modules/flex-container";

export const AssetTypeTemplateInfo = ({
  entityTemplate,
}: AssetTypeTemplateInfoProps) => {
  const { t } = useTranslation();

  const { name } = entityTemplate;
  const { assetTypes, isLoading } = useGetEntityTemplateAssetTypes(
    entityTemplate.id
  );

  return (
    <Flex vertical gap="small">
      {name && (
        <FlexContainerText
          value={name}
          label={t("technicalForm:form.name.label")}
        />
      )}

      <FlexContainerJsx
        value={
          <AssetTypesListBreadcrumb
            assetTypes={assetTypes}
            isLoading={isLoading}
          />
        }
        label={t("technicalForm:form.usedInAssetType.label")}
      />
    </Flex>
  );
};
